import { gql } from '@apollo/client';

export const FETCH_ALL_DIAGNOSTIC_REPORTS_QUERY = gql`
  query fetchAllDiagnosticReports(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllDiagnosticReports(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      diagnosticList
      count
    }
  }
`;

export const FETCH_DIAGNOSTIC_REPORT_DETAILS_BY_ID = gql`
  query fetchDiagnosticReportById($diagnosticReportId: String) {
    fetchDiagnosticReportById(diagnosticReportId: $diagnosticReportId) {
      diagnosticReport
      docArn
      documentReferenceId
    }
  }
`;
